import { render, staticRenderFns } from "./CampusEditModal.vue?vue&type=template&id=028260db&"
import script from "./CampusEditModal.vue?vue&type=script&lang=js&"
export * from "./CampusEditModal.vue?vue&type=script&lang=js&"
import style0 from "./CampusEditModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports